import {
	Breakpoints,
	BreakpointWrapper,
	Container,
	ContainerPadding,
	Richtext,
	styled,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { Oferta } from '../../../services/ofertas-service/models/ofertas';

const OfertaCardDescriptionContainer = styled.div`
	p {
		margin: 0;
	}
`;

export const OfertaCardDescriptionDesktop = ({ oferta }: { oferta: Oferta; className: string }): React.ReactElement => {
	return (
		<OfertaCardDescriptionContainer>
			{oferta.titulo && (
				<Container padding={{ top: ContainerPadding.static200 }} stretchContent>
					<BreakpointWrapper min={Breakpoints.default} max={Breakpoints.b1920}>
						<Text appearance={TokenTextAppearance.copy100} bold>
							{oferta.titulo}
						</Text>
					</BreakpointWrapper>
					<BreakpointWrapper min={Breakpoints.b1920}>
						<Text appearance={TokenTextAppearance.copy100} bold>
							{oferta.titulo}
						</Text>
					</BreakpointWrapper>
				</Container>
			)}

			{/* oferta.descripcion && oferta.pff.basic == 0 && */}
			{oferta.descripcion && (
				<Container padding={{ top: ContainerPadding.static100 }} stretchContent>
					<BreakpointWrapper min={Breakpoints.default} max={Breakpoints.b1920}>
						<Text appearance={TokenTextAppearance.copy100}>
							<Richtext markdown={oferta.descripcion} dangerouslyParseRawHTML />
						</Text>
					</BreakpointWrapper>
					<BreakpointWrapper min={Breakpoints.b1920}>
						<Richtext markdown={oferta.descripcion} dangerouslyParseRawHTML />
					</BreakpointWrapper>
				</Container>
			)}
		</OfertaCardDescriptionContainer>
	);
};
